// extracted by mini-css-extract-plugin
export default {"wrapper":"dialogHeader_wrapper__bXH-l","icon":"dialogHeader_icon__zoX+9"};